module.exports = __webpack_public_path__ + "img/paraguay.a339cbf6.svg";